import { render, staticRenderFns } from "./SuppliersView.vue?vue&type=template&id=230680f8&scoped=true&"
import script from "./SuppliersView.vue?vue&type=script&lang=js&"
export * from "./SuppliersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230680f8",
  null
  
)

export default component.exports